import { ClientAttributes, CryptoService } from '@pulse/common';

export class SettingsHelper {
    constructor(private crypto: CryptoService) {}

    shouldReturnDefaultValue(
        remoteSettingEnabled: boolean,
        firstCallState: { firstCallDone: boolean; defaultReturned: boolean },
        settingName: string,
        tag: string,
        cache?: { cachedSetting: Record<string, any>; timedOut: boolean },
    ): boolean {
        // If remote setting is disabled, always return default
        if (!remoteSettingEnabled) {
            return true;
        }

        // If first call hasn't completed and default was returned, use default
        if (firstCallState.firstCallDone && firstCallState.defaultReturned) {
            return true;
        }

        const emptyForTags: string[] =
            typeof cache?.cachedSetting['emptyForTags'] === 'string'
                ? cache.cachedSetting['emptyForTags'].split(',')
                : [];

        if (
            !cache?.timedOut &&
            cache?.cachedSetting[settingName] === undefined &&
            emptyForTags.includes(tag)
        ) {
            return true;
        }

        return false;
    }

    getAttributesHash({
        tag,
        attributes,
        userRole,
        isTest,
        userId,
        tierId,
        deviceLastTierId,
        debugExperiment,
        appVersion,
    }: {
        tag: string;
        attributes: ClientAttributes;
        userRole: string;
        isTest: string;
        userId: string;
        tierId: string;
        deviceLastTierId: string;
        debugExperiment: string;
        appVersion: string;
    }): string {
        return this.crypto.unsafeShortHash(
            `${tag}-${userRole}-${isTest}-${userId}-${tierId}-${deviceLastTierId}-${debugExperiment}-${JSON.stringify(
                attributes,
            )}-${appVersion}`,
        );
    }
}
